// @flow

import * as React from 'react';

import type { DomainProduct } from '@gandi/cart';
import type { Organization } from '@gandi/redux-organization';
import { useTranslator } from '@gandi/translate';
import { Pills, PillsPanel } from '@gandi/ui';

import FileForm from './FileForm';
import SelectForm from './SelectForm';

type Props = {
  setupOwnerOrga: Organization,
  product: DomainProduct,
  checking: boolean,
  setSelectedSmdId: string => void,
  setChecking: boolean => void,
  removedByUser: boolean,
  setRemovedByUser: boolean => void,
};

export default function InputPills({
  setupOwnerOrga,
  product,
  checking,
  setChecking,
  setSelectedSmdId,
  removedByUser,
  setRemovedByUser,
}: Props): React.Node {
  const { __ } = useTranslator();

  return (
    <Pills>
      <PillsPanel label={__('Select existing')} key="select-smd">
        <h3>
          {__('SMD file from %(organame)s', {
            organame: setupOwnerOrga?.orgname || setupOwnerOrga?.name || '',
          })}
        </h3>
        <SelectForm
          checking={checking}
          product={product}
          setSelectedSmdId={setSelectedSmdId}
          setChecking={setChecking}
        />
      </PillsPanel>

      <PillsPanel label={__('Upload file')} key="upload-smd">
        <FileForm
          checking={checking}
          product={product}
          setChecking={setChecking}
          removedByUser={removedByUser}
          setRemovedByUser={setRemovedByUser}
        />
      </PillsPanel>
    </Pills>
  );
}
